export const AppSettings = {
  supportedLanguages: {
    english: "ENGLISH",
    nepali: "NEPALI",
    chinese: "CHINESE",
  },
};
